module.exports = __webpack_public_path__ + "static/b.logo-587470e17c1a35eba2f509ad7bed4c65.gif";